import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';

const FlexPanel = ({ children, className, toolbar, header, ...rest }) => {
  return (
    <Card className={classNames('flex-panel', className)} {...rest}>
      <Card.Header>
        <div className="card-toolbar">{toolbar}</div>
        <Card.Title>{header}</Card.Title>
      </Card.Header>
      <Card.Body>
        <div style={{ display: 'block', width: '100%' }}>{children}</div>
      </Card.Body>
    </Card>
  );
};

FlexPanel.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  toolbar: PropTypes.any,
};

export default FlexPanel;
